<template>
  <div id="app">
    <div class="container">
      <div class="row justify-content-md-center">
        <div class="col-lg-6">
          <div class="card animated fadeIn clarity" v-show="section===1">
            <div class="card-body">
              <h5 class="card-title main">
                <img src="./images/clarity.png" />
                Clarity
              </h5>
              <div class="card-text">
                <p>Does the behaviour/action explicitly breach:</p>
                <ul>
                  <li>policy (such as NHS trust policy for internet use)</li>
                  <li>professional guidelines</li>
                  <li>clinical guidelines?</li>
                </ul>
                <p>If so, can you locate the breach in the document(s)?</p>
              </div>
              <p>
                <button class="btn btn-success btn-lg" @click="section++">Start Process</button>
              </p>
            </div>
          </div>

          <div class="card animated fadeIn clarity" v-show="section===2">
            <div class="card-body">
              <h5 class="card-title">
                <img src="./images/clarity_1.png" />
                Professional
              </h5>
              <div class="card-text">
                <p>1. Professional accountability</p>
                <ul>
                  <li>Is there a breach of confidentiality?</li>
                  <li>Is there a breach of professional boundaries or guidelines?</li>
                  <li>
                    Could there be damage to the reputation of your profession as a result of
                    the content?
                  </li>
                </ul>
              </div>
              <p>
                <button
                  class="btn btn-success btn-lg"
                  @click="AnswerObject.clarity.professional=true; section++"
                >Yes</button>
                <button
                  class="btn btn-danger btn-lg"
                  @click="AnswerObject.clarity.professional=false; section++"
                >No</button>
              </p>
            </div>
          </div>

          <div class="card animated fadeIn clarity" v-show="section===3">
            <div class="card-body">
              <h5 class="card-title">
                <img src="./images/clarity_2.png" />
                Legal
              </h5>
              <div class="card-text">
                <p>2. Legal accountability</p>
                <ul>
                  <li>
                    Is there a potential breach of any civil or criminal law? For example, is
                    there evidence of violence, illegal substance misuse?
                  </li>
                </ul>
              </div>
              <p>
                <button
                  class="btn btn-success btn-lg"
                  @click="AnswerObject.clarity.legal=true; section++"
                >Yes</button>
                <button
                  class="btn btn-danger btn-lg"
                  @click="AnswerObject.clarity.legal=false; section++"
                >No</button>
              </p>
            </div>
          </div>

          <div class="card animated fadeIn clarity" v-show="section===4">
            <div class="card-body">
              <h5 class="card-title">
                <img src="./images/clarity_3.png" /> Employment
              </h5>
              <div class="card-text">
                <p>3. Employer accountability</p>
                <ul>
                  <li>
                    Is there evidence that company/organisational policy has been breached?
                    For example, bullying/harassment, taking holiday when declaring ‘sick
                    leave’.
                  </li>
                </ul>
              </div>
              <p>
                <button
                  class="btn btn-success btn-lg"
                  @click="AnswerObject.clarity.employment=true; section++"
                >Yes</button>
                <button
                  class="btn btn-danger btn-lg"
                  @click="AnswerObject.clarity.employment=false; section++"
                >No</button>
              </p>
            </div>
          </div>

          <div class="card animated fadeIn clarity" v-show="section===5">
            <div class="card-body">
              <h5 class="card-title">
                <img src="./images/clarity_4.png" />
                Ethical intent
              </h5>
              <div class="card-text">
                <p>4. Ethical intent?</p>
                <ol type="a">
                  <li>Justice – balance between need and resources</li>
                  <li>Autonomy – respecting values of people/persons</li>
                  <li>Beneficence – acting for the benefit of others</li>
                  <li>Non-maleficence – not causing harm</li>
                </ol>
              </div>
              <p>
                <button
                  class="btn btn-success btn-lg"
                  @click="AnswerObject.clarity.ethical=true; section++"
                >Yes</button>
                <button
                  class="btn btn-danger btn-lg"
                  @click="AnswerObject.clarity.ethical=false; section++"
                >No</button>
              </p>
            </div>
          </div>

          <div class="card animated fadeIn result" v-show="section===6">
            <div class="card-body">
              <div
                v-if="!AnswerObject.clarity.professional&&!AnswerObject.clarity.ethical&&!AnswerObject.clarity.legal&&!AnswerObject.clarity.employment"
              >
                <h5 class="card-title">No Evidence</h5>
                <p class="card-text">There is no evidence of a breach.</p>
                <p>
                  <button class="btn btn-danger btn-lg" @click="section=-1">Finish</button>
                </p>
              </div>

              <div v-else>
                <h5 class="card-title">Evidence Available?</h5>
                <div class="card-text">
                  <p>So, does the behaviour/action explicitly breach things like:</p>

                  <ul>
                  <li>policy (such as NHS trust policy for internet use)</li>
                  <li>professional guidelines</li>
                  <li>clinical guidelines?</li>
                   </ul>
                  <p>If so, can you locate the breach in the document(s)?</p>
        
                </div>
                <button class="btn btn-success btn-lg" @click="section++">Yes</button>
                <button class="btn btn-danger btn-lg" @click="section=-1">No</button>
              </div>
            </div>
          </div>

          <div class="card animated fadeIn context" v-show="section===7">
            <div class="card-body">
              <h5 class="card-title main">
                <img src="./images/context.png" />
                Context
              </h5>
              <p class="card-text">
                Can you explain/describe the context of the situation that led to the
                incident/behaviour/event? For example, when, where and in what
                circumstances it occurred.
              </p>
              <p>
                <button class="btn btn-success btn-lg" @click="section++">Start Process</button>
              </p>
            </div>
          </div>

          <div class="card animated fadeIn context" v-show="section===8">
            <div class="card-body">
              <h5 class="card-title">
                <img src="./images/context_1.png" /> Professional
              </h5>
              <div class="card-text">
                <p>1. Professional accountability</p>
                 <ul>
                <li>
                  Is there evidence that when the event/behaviour occurred the person was
                  in a professional capacity?
                </li>
                <li>
                  Would you expect another person, with the same professional status to
                  behave in the same way? For example, student nurses and their level of
                  ‘competency’/stage of study
                </li>
                 </ul>
              </div>
              <p>
                <button
                  class="btn btn-success btn-lg"
                  @click="AnswerObject.context.professional=true; section++"
                >Yes</button>
                <button
                  class="btn btn-danger btn-lg"
                  @click="AnswerObject.context.professional=false; section++"
                >No</button>
              </p>
            </div>
          </div>

          <div class="card animated fadeIn context" v-show="section===9">
            <div class="card-body">
              <h5 class="card-title">
                <img src="./images/context_2.png" /> Legal
              </h5>
              <div class="card-text">
                <p>2. Legal accountability</p>
                <ul>
                <li>
                  Think about the event and the time and place. Was the behaviour legal in
                  the place and timeframe when it occurred? For example, was this shared from
                  many years ago and has the law changed since this time or, what is the law
                  in the country in which it occurred?
                </li>
                <li>Is this explicit?</li>
                </ul>
              </div>
              <p>
                <button
                  class="btn btn-success btn-lg"
                  @click="AnswerObject.context.legal=true; section++"
                >Yes</button>
                <button
                  class="btn btn-danger btn-lg"
                  @click="AnswerObject.context.legal=false; section++"
                >No</button>
              </p>
            </div>
          </div>

          <div class="card animated fadeIn context" v-show="section===10">
            <div class="card-body">
              <h5 class="card-title">
                <img src="./images/context_3.png" /> Employment
              </h5>
              <div class="card-text">
                <p>3. Employer accountability</p>
                <ul>
                <li>
                  Can the action or behaviour be directly related to the workplace? For
                  example, was the individual drinking alcohol or intoxicated at 3am and
                  attended a shift at 7am the following day or, did the individual share the
                  content during working hours and when they were not on a break?
                </li>
                </ul>
              </div>
              <p>
                <button
                  class="btn btn-success btn-lg"
                  @click="AnswerObject.context.employment=true; section++"
                >Yes</button>
                <button
                  class="btn btn-danger btn-lg"
                  @click="AnswerObject.context.employment=false; section++"
                >No</button>
              </p>
            </div>
          </div>

          <div class="card animated fadeIn context" v-show="section===11">
            <div class="card-body">
              <h5 class="card-title">
                <img src="./images/context_4.png" /> Ethical intent
              </h5>
              <div class="card-text">
                <p>4. Ethical intent and consequence</p>
                <ul>
                <li>Justice – balance between need and resources</li>
                <li>Autonomy – respecting values of people/persons</li>
                <li>Beneficence – acting for the benefit of others</li>
                <li>Non-maleficence – not causing harm</li>
                <li>
                  Are the consequences of the event/incident acceptable when considering
                  the four components of ethical intent?
                </li>
                <li>
                  Who was the content accessible to? For example, if only shared with
                  family and close friends this is likely to cause less harm in some
                  circumstances
                </li>
                <li>Were there exceptional circumstances? For example, emergency situations.</li>
                </ul>
              </div>
              <p>
                <button
                  class="btn btn-success btn-lg"
                  @click="AnswerObject.context.ethical=true; section++"
                >Yes</button>
                <button
                  class="btn btn-danger btn-lg"
                  @click="AnswerObject.context.ethical=false; section++"
                >No</button>
              </p>
            </div>
          </div>

          <div class="card animated fadeIn result" v-show="section===12">
            <div class="card-body">
              <div
                v-if="!AnswerObject.context.professional&&!AnswerObject.context.ethical&&!AnswerObject.context.legal&&!AnswerObject.context.employment"
              >
                <h5 class="card-title">No Evidence</h5>
                <p class="card-text">There is no evidence of a breach.</p>
                <p>
                  <button class="btn btn-danger btn-lg" @click="section=-1">Finish</button>
                </p>
              </div>

              <div v-else>
                <h5 class="card-title">Evidence Available?</h5>
                <p class="card-text">
                  Can you clearly describe and explain the context and how this breaches the
                  policy/guidelines found during the first stage of this process?
                </p>
                <button class="btn btn-success btn-lg" @click="section++">Yes</button>
                <button class="btn btn-danger btn-lg" @click="section=-1">No</button>
              </div>
            </div>
          </div>

          <div class="card animated fadeIn confirmability" v-show="section===13">
            <div class="card-body">
              <h5 class="card-title main">
                <img src="./images/confirmability.png" />
                Confirmability
              </h5>
              <div class="card-text">
                <p>
                  Can you be sure that the professional was the person who committed the
                  offence, shared the content in the context described?
                </p>
                <p>Can you confirm and clearly evidence the consequences of the behaviour?</p>
              </div>
              <p>
                <button class="btn btn-success btn-lg" @click="section++">Start Process</button>
              </p>
            </div>
          </div>

          <div class="card animated fadeIn confirmability" v-show="section===14">
            <div class="card-body">
              <h5 class="card-title">
                <img src="./images/confirmability_1.png" /> Professional
              </h5>
              <div
                class="card-text"
              >
              <p>
    1. Professional accountability
</p>
<ul>
<li>
    Is the person clearly identifiable as a registered professional?
</li>
<li>
    Can you confirm the content was shared by the professional and in the
    capacity of a professional?
</li>
</ul>
              </div>
              <p>
                <button
                  class="btn btn-success btn-lg"
                  @click="AnswerObject.confirmability.professional=true; section++"
                >Yes</button>
                <button
                  class="btn btn-danger btn-lg"
                  @click="AnswerObject.confirmability.professional=false; section++"
                >No</button>
              </p>
            </div>
          </div>

          <div class="card animated fadeIn confirmability" v-show="section===15">
            <div class="card-body">
              <h5 class="card-title">
                <img src="./images/confirmability_2.png" /> Legal
              </h5>
              <div
                class="card-text"
              >
              <p>
    2. Legal accountability
</p>

<p>
    Was the action legal at the time it occurred? If the action has already
    been punished/dealt with then does it need further action?
</p>
</div>
              <p>
                <button
                  class="btn btn-success btn-lg"
                  @click="AnswerObject.confirmability.legal=true; section++"
                >Yes</button>
                <button
                  class="btn btn-danger btn-lg"
                  @click="AnswerObject.confirmability.legal=false; section++"
                >No</button>
              </p>
            </div>
          </div>

          <div class="card animated fadeIn confirmability" v-show="section===16">
            <div class="card-body">
              <h5 class="card-title">
                <img src="./images/confirmability_3.png" /> Employment
              </h5>
              <div
                class="card-text"
              >
              <p>
    3. Employer accountability
</p>
<p>
    Can you be sure the professional was working for the employer at that
    time?
</p>
              </div>
              <p>
                <button
                  class="btn btn-success btn-lg"
                  @click="AnswerObject.confirmability.employment=true; section++"
                >Yes</button>
                <button
                  class="btn btn-danger btn-lg"
                  @click="AnswerObject.confirmability.employment=false; section++"
                >No</button>
              </p>
            </div>
          </div>

          <div class="card animated fadeIn confirmability" v-show="section===17">
            <div class="card-body">
              <h5 class="card-title">
                <img src="./images/confirmability_4.png" /> Ethical intent
              </h5>
              <div class="card-text">
          <p>
    4. Ethical intent and consequence
</p>
<ul>
<li>
    Can you confirm the consequences? Who was affected, how, when and why?
    What was the extent of the impact?
</li>
<li>
    Justice – balance between need and resources
</li>
<li>
    Autonomy – respecting values of people/persons
</li>
<li>
    Beneficence – acting for the benefit of others
</li>
<li>
    Non-maleficence – not causing harm
</li>
</ul>
              </div>
              <p>
                <button
                  class="btn btn-success btn-lg"
                  @click="AnswerObject.confirmability.ethical=true; section++"
                >Yes</button>
                <button
                  class="btn btn-danger btn-lg"
                  @click="AnswerObject.confirmability.ethical=false; section++"
                >No</button>
              </p>
            </div>
          </div>

          <div class="card animated fadeIn result" v-show="section===18">
            <div class="card-body">
              <div
                v-if="!AnswerObject.confirmability.professional&&!AnswerObject.confirmability.ethical&&!AnswerObject.confirmability.legal&&!AnswerObject.confirmability.employment"
              >
                <h5 class="card-title">No Evidence</h5>
                <p class="card-text">There is no evidence of a breach.</p>
                <p>
                  <button class="btn btn-danger btn-lg" @click="section=-1">Finish</button>
                </p>
              </div>

              <div v-else>
                <h5 class="card-title">Evidence Available?</h5>
                <p class="card-text">
                Can you bring together all of the evidence gathered from ‘context’ and
    ‘clarity’ stages and put together a case?
                </p>
                <button class="btn btn-success btn-lg" @click="section=-2">Yes</button>
                <button class="btn btn-danger btn-lg" @click="section=-1">No</button>
              </div>
            </div>
          </div>

          <div class="card animated fadeIn result" v-show="section===-1">
            <div class="card-body">
              <h5 class="card-title">Intervention</h5>
              <p class="card-text">
                It might be difficult to prove a breach. It might be worth revising privacy
                settings, reflection on the incident and raise awareness of the issues with
                sharing such information online.
              </p>
              <p></p>
            </div>
          </div>

          <div class="card animated fadeIn" v-show="section===-2">
            <div class="card-body">
              <h1 class="card-title">Breach</h1>
              <div class="card-text">
                 This is potentially a breach and will likely need to be reported,
    investigated and could result in disciplinary action and/or referral to the
    professional body.
              </div>
            </div>
          </div>

          <table class="table table-striped">
            <thead class="thead-dark">
              <tr>
                <th></th>
                <th>Clarity</th>
                <th>Context</th>
                <th>Confirmability</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th>Professional</th>
                <td>
                  <i v-if="AnswerObject.clarity.professional" class="material-icons">check_box</i>
                  <i class="material-icons" v-else>check_box_outline_blank</i>
                </td>
                <td>
                  <i v-if="AnswerObject.context.professional" class="material-icons">check_box</i>
                  <i class="material-icons" v-else>check_box_outline_blank</i>
                </td>
                <td>
                  <i
                    v-if="AnswerObject.confirmability.professional"
                    class="material-icons"
                  >check_box</i>
                  <i class="material-icons" v-else>check_box_outline_blank</i>
                </td>
              </tr>
              <tr>
                <th>Legal</th>
                <td>
                  <i v-if="AnswerObject.clarity.legal" class="material-icons">check_box</i>
                  <i class="material-icons" v-else>check_box_outline_blank</i>
                </td>
                <td>
                  <i v-if="AnswerObject.context.legal" class="material-icons">check_box</i>
                  <i class="material-icons" v-else>check_box_outline_blank</i>
                </td>
                <td>
                  <i v-if="AnswerObject.confirmability.legal" class="material-icons">check_box</i>
                  <i class="material-icons" v-else>check_box_outline_blank</i>
                </td>
              </tr>
              <tr>
                <th>Employment</th>
                <td>
                  <i v-if="AnswerObject.clarity.employment" class="material-icons">check_box</i>
                  <i class="material-icons" v-else>check_box_outline_blank</i>
                </td>
                <td>
                  <i v-if="AnswerObject.context.employment" class="material-icons">check_box</i>
                  <i class="material-icons" v-else>check_box_outline_blank</i>
                </td>
                <td>
                  <i v-if="AnswerObject.confirmability.employment" class="material-icons">check_box</i>
                  <i class="material-icons" v-else>check_box_outline_blank</i>
                </td>
              </tr>
              <tr>
                <th>Ethical</th>
                <td>
                  <i v-if="AnswerObject.clarity.ethical" class="material-icons">check_box</i>
                  <i class="material-icons" v-else>check_box_outline_blank</i>
                </td>
                <td>
                  <i v-if="AnswerObject.context.ethical" class="material-icons">check_box</i>
                  <i class="material-icons" v-else>check_box_outline_blank</i>
                </td>
                <td>
                  <i v-if="AnswerObject.confirmability.ethical" class="material-icons">check_box</i>
                  <i class="material-icons" v-else>check_box_outline_blank</i>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      section: 1,
      AnswerObject: {
        clarity: {
          professional: false,
          legal: false,
          employment: false,
          ethical: false
        },
        context: {
          professional: false,
          legal: false,
          employment: false,
          ethical: false
        },
        confirmability: {
          professional: false,
          legal: false,
          employment: false,
          ethical: false
        }
      }
    };
  },
  mounted(){
    VLE.resize_iframe();
  },
  updated(){
       VLE.resize_iframe();
  }
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.card {
  margin-bottom: 10px;
}
.btn {
  margin: 10px;
}
.card-body {
  padding: 0px;
  min-height: 400px;
}
.card-text {
  padding: 10px;
  font-size: 1.1rem;
  text-align: left;
  padding-left: 50px;
  padding-right: 50px;
}
.clarity {
  background-color: #f6ebf0;
}
.clarity h5 {
  display: block;
  padding: 10px;
  text-align: left;
  font-size: 3rem;
  color: #b65783;
}
.clarity .main {
  background-color: #f4b5d0;
}

.context h5 {
  display: block;
  padding: 10px;
  text-align: left;
  font-size: 3rem;
  color: #22abd8;
}
.context .main {
  background-color: #9ed0e9;
}

.confirmability h5 {
  display: block;
  padding: 10px;
  text-align: left;
  font-size: 3rem;
  color: #01a4a6;
}
.confirmability .main {
  background-color: #b3dddc;
}

.context {
  background-color: #e8f2f9;
}

.confirmability {
  background-color: #eef7f6;
}

.result h5 {
  display: block;
  padding: 20px;
  font-size: 2rem;
  color: #424242;
}
</style>
